export default __webpack_public_path__ + "7a08297d4da4d48cd57d3fdee46532d5.png";